import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store/index'

Vue.use(Router)

const Page = () => import(/* webpackChunkName "page" */ '@/views/Page')
const Article = () => import(/* webpackChunkName "library" */ '@/views/Article')
const BlueProject = () => import(/* webpackChunkName "blue-project" */ '@/views/BlueProject/BlueProject')
const Overview = () => import(/* webpackChunkName "blue-project" */ '@/views/BlueProject/Overview')
const Artworks = () => import(/* webpackChunkName "blue-project" */ '@/views/BlueProject/Artworks')
const Views = () => import(/* webpackChunkName "blue-project" */ '@/views/BlueProject/Views')
const Category = () => import(/* webpackChunkName "library" */ '@/views/Category')
const Products = () => import(/* webpackChunkName "shop" */ '@/views/products/Index')
const ProductsIndex = () => import(/* webpackChunkName "shop" */ '@/views/products/ProductsIndex')
const ProductsCollection = () => import(/* webpackChunkName "shop" */ '@/views/products/ProductsCollection')
const Product = () => import(/* webpackChunkName "shop" */ '@/views/products/Product')
const Showroom = () => import(/* webpackChunkName "showroom" */ '@/views/products/Showroom')

const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/library/category/:cat',
      name: 'category',
      component: Category,
      props: true
    },
    {
      path: '/library/:slug',
      name: 'article',
      component: Article,
      props: true
    },
    {
      path: '/blue-projects/:slug',
      component: BlueProject,
      props: true,
      children: [
        {
          path: '',
          name: 'blue-project',
          component: Overview,
          meta: { label: 'Overview' }
        },
        {
          path: 'artworks',
          name: 'blue-project/artworks',
          component: Artworks,
          meta: { label: 'Artworks' }
        },
        {
          path: 'views',
          name: 'blue-project/views',
          component: Views,
          meta: { label: 'Views' }
        }
      ]
    },
    {
      path: '/hostem/products',
      component: Products,
      children: [
        {
          path: '',
          name: 'products',
          component: ProductsIndex
        },
        {
          path: '/hostem/collections/:collection',
          name: 'products_collection',
          component: ProductsCollection,
          props: true
        },
        {
          path: '/hostem/collections/:collection/:handle',
          name: 'collection_product',
          component: Product,
          props: true
        },
        {
          path: '/hostem/products/:handle',
          name: 'product',
          component: Product,
          props: true
        }
      ]
    },
    {
      path: '/hostem/showroom/:showroom',
      name: 'showroom',
      component: Showroom,
      props: true
    },
    {
      path: '/:parent*/:slug',
      name: 'page',
      component: Page,
      props: true
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // disable browser handling saved position
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual'
    // wait for the out transition to complete
    return new Promise(resolve => {
      this.app.$root.$once('triggerScroll', () => {
        const position = savedPosition || { x: 0, y: 0 }
        resolve(position)
      })
    })
  }
})

router.afterEach((to, from) => {
  if (store.state.site) {
    store.commit('CHANGE_THEME', to.path)
  }
})

export default router
